import axios from "axios";
import React, { useEffect } from "react";
import CheckBox from "../../../../Components/CheckBox/CheckBox";
import Modal from "../../../../Components/Modal/Modal";
import Stepper from "../../../../Components/Stepper/Stepper";
import { Button, Input, Textarea } from "../../../../Components/StyledComponents";
import { convertCost, languageInit, onTranslation, onlyNum } from "../../../../Utils/functions";
import './CreateMenu.scss';
import {cloneDeep} from 'lodash-es';
import ReactDragListView from 'react-drag-listview';
import Select from 'react-select'
import { useSelector } from "react-redux";
import { support_language } from "../../../../Utils/services";
import CheckLanguage from "../../../../Components/PickupOrder/CheckLanguage";

const ModifyMenu = ({info,patchMenu}) => {
    const [ step, setStep ] = React.useState(1)
    const [ name, setName ] = React.useState({})
    const [ price, setPrice ] = React.useState([{PosItem:'', Name : languageInit(), Price : 0 }])
    const [ desc, setDesc ] = React.useState({})
    const [ options, setOptions ] = React.useState([]);
    const [ optionIds, setOptionIds ] = React.useState([]);
    const [ optionList, setOptionList ] = React.useState([]);
    const [ limit, setLimit ] = React.useState({});
    const language = useSelector(state => state.tableorder.language);

    useEffect(() => {
        getOptionGroup();
        setName(cloneDeep(info.Name));
        setPrice(cloneDeep(info.Price));
        setDesc(cloneDeep(info.Description));
        if(typeof info.Limit !== 'undefined') setLimit(cloneDeep(info.Limit));
        else setLimit(cloneDeep({Store: 0, Max: 0, Min: 0}));
    },[])

    const getOptionGroup = () => {
        axios.get('/api/pickup/order/menu/option/group')
        .then((data)=>{
            let arr = [];
            let newarr = []
            setOptionList(data.data)
            for( let i=0; i < info.OptionGroupIds.length; i++){
                arr.push(info.OptionGroupIds[i].$oid)
                let index = data.data.findIndex( item => item._id.$oid === info.OptionGroupIds[i].$oid)
                newarr.push(data.data[index])
            }
            setOptionIds(arr)
            /* for(let i=0; i < data.data.length; i++){
                if( arr.indexOf(data.data[i]._id.$oid) !== -1){
                    newarr.push(data.data[i])
                }
            } */
            setOptions(newarr)
        })
    }

    const optionRef = React.useRef(null)

    const addPrice = () => {
        setPrice(old => [...old, {PosItem:'', Name : languageInit(), Price : 0}])
    }

    const handlePrice = (val,i) => {
        let arr = price;
        arr[i].Price = onlyNum(val);

        setPrice([...arr])
    }

    const handlePriceName = (val,i) => {
        let arr = price;

        arr[i].Name = val;

        setPrice([...arr])
    }

    const removePrice = (i) => {
        let arr = price;

        arr.splice(i,1);

        setPrice([...arr])
    }

    const nextStep = () => {
        if(step !== 5) setStep(old => old+1)
        else patch()
    }

    const handleOptions = (data) => {
        let index;

        index = optionIds.findIndex(item => item === data._id.$oid)

        if(index === -1){
            setOptionIds(old => [...old,data._id.$oid])
            setOptions(old => [...old,data])
        }else {
            setOptionIds(optionIds.filter(item => item !== data._id.$oid));
            setOptions(options.filter(item => item._id.$oid !== data._id.$oid))
        }
    }

    const getChecked = (id) => {
        let index = optionIds.findIndex(item => item === id);
        if( index === -1 ) return false;
        else return true
    }

    const isDisabled = () => {
        if(step === 1 && ( name.ko?.trim() === '' || price.length === 0 || !price.every(item => item.Name !== '') )) return true;
        else return false
    }

    const patch = () => {
        let arr = [];
        for(let i=0; i < price.length; i++){
            arr.push({PosItem: price[i].PosItem, Name : price[i].Name, Price: price[i].Price})
        }

        patchMenu({
            MenuId : info._id.$oid,
            Name : name,
            Description : desc,
            Price : arr,
            OptionGroupIds : optionIds,
            Limit: limit,
        })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
          const data = [...options];
          const item = data.splice(fromIndex, 1)[0];
          data.splice(toIndex, 0, item);
          setOptions([...data]);

          const ids = [...optionIds];
          const id = ids.splice(fromIndex,1)[0];
          ids.splice(toIndex,0,id)
          setOptionIds([...ids])
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName : 'line',
    };
    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko, ...price.map(item => item.Name.ko)];
        const trans_value = ['name', 'desc', ...price.map((item, index) => ({value: 'price', index: index, key: 'Name', data: item}))];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
        setPrice([...data.price]);
    };

    return (
        <div className="create-menu">
            <Stepper maxStep={5} step={step} containerStyle={{ marginBottom : step === 5 ? 0 : 40 }}/>
            {
                step === 5 && <p className="warn-text">모두 입력되었어요. 마지막으로 확인해주세요.</p>
            }
            {
                step === 1 &&
                <div>
                    <div className="row">
                        <p className="label">메뉴명</p>
                        
                        <Input value={name.ko} placeholder={"예) 매운떡볶이"} onChange={(e) => setName({...name, ko: e.target.value})} style={{ width : 351 }} />
                    </div>

                    <div style={{ marginTop : 32, marginBottom : 16 }}>
                        <p className="label">가격구성</p>
                        <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 픽업 오더에 보여지는 메뉴 이름만 설정할 수 있습니다.</p>
                        <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 금액 변경을 원하실 경우 포스에서 메뉴 정보를 변경해주세요.</p>
                        {
                            price.map((data,i) => {
                                return (
                                    <div key={i}>
                                        <div className="row" style={{ marginTop : 16, marginBottom: 8 }}>
                                            <Input value={price[i].Name.ko} onChange={(e) => handlePriceName({...price[i].Name, ko: e.target.value},i)} placeholder="예) 1인분, 300g 등" style={{ width : 230, marginRight: 16, paddingLeft: 16, paddingRight: 16 }}/>
                                            <label htmlFor={`price${i}`} data-domain="원">
                                                <Input htmlFor={`price${i}`} value={price[i].Price} onChange={(e) => handlePrice(e.target.value, i)} placeholder="0" style={{ color:'#0F0F0F', width : 120, paddingLeft: 16, paddingRight: 16 }}/>
                                            </label>
                                            <Button variant="sub" onClick={()=> removePrice(i)} style={{ width : 28, height : 28, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 16 }}>
                                                <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 16, height : 16, marginTop : 6 }} />
                                            </Button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <Button variant="sub" onClick={() => addPrice()} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                        <div className='row'>
                            <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            추가하기
                        </div>
                    </Button>
                </div>                    
            }

            {
                step === 2 &&
                <div className='row' style={{ alignItems : 'flex-start' }}>
                    <p className='label'>설명(선택)</p>
                    <Textarea
                        value={desc.ko}
                        onChange={(e) => setDesc({...desc, ko: e.target.value})}
                        style={{ width : 347, height : 173 }}
                        placeholder="예) 세트 구성 메뉴입니다."
                    />
                </div>
            }
            {
                step === 3 &&
                <div style={{ alignItems : 'flex-start' }}>
                    <CheckLanguage>
                        <div style={{display:'flex', flexDirection:'column'}}>
                        <div className='btn-row' style={{margin:0, alignItems:'center'}}>
                            <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                            <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                                자동번역
                            </Button>
                        </div>
                        {support_language.map((item, index) => {
                            if(language[item.value])
                                return (
                                    <div style={{display:'flex', flexDirection:'column', marginBottom: 24, rowGap: 8}} key={index}>
                                        {index !== 0 && <div className='divider' style={{margin: '16px 0'}} />}
                                        <p className='title' style={{marginBottom: 8}}>{item.text}</p>
                                        <div className="row">
                                            <p className='label'>메뉴명</p>
                                            <Input value={name[item.value]} placeholder={"예) 매운떡볶이"} onChange={(e) => setName({...name, [item.value]: e.target.value})} style={{ width : '100%' }} />
                                        </div>
                                        <div className="row">
                                            <p className='label'>설명</p>
                                            <Textarea
                                                value={desc[item.value]}
                                                onChange={(e) => setDesc({...desc, [item.value]: e.target.value})}
                                                style={{ width : '100%', height : 173 }}
                                                placeholder="예) 세트 구성 메뉴입니다."
                                            />
                                        </div>
                                        
                                        <div className="row">
                                            <p className='label'>가격구성</p>
                                            <div style={{ display:'flex', flexDirection:'column', width:'100%', gap: 8 }}>
                                                {price.map((data,i) => (
                                                    <Input key={i} value={price[i].Name[item.value]} onChange={(e) => handlePriceName({...price[i].Name, [item.value]: e.target.value}, i)} placeholder="예) 1인분, 300g 등" style={{ width : '100%' }}/>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )
                        })}
                        </div>
                    </CheckLanguage>
                </div>
            }
            {
                step === 4 &&
                <div>
                    <div className="row between" style={{ marginBottom : 8 }}>
                        <p className="label" style={{ width : 'fit-content' }}>옵션 추가 (선택)</p>
                        <Button variant="sub" small onClick={() => optionRef.current.openModal()}>
                            <div className='row'>
                                <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                                추가하기
                            </div>
                        </Button>
                    </div>
                    <ReactDragListView {...dragProps}>
                    {
                        options.length === 0 ?
                        <p className="label" style={{ opacity : 0.5, width : 'fit-content' }}>메뉴 주문시 메뉴의 맛이나 토핑, 추가메뉴,음료 등의<br/> 옵션메뉴를 설정할 수 있어요.</p>
                        :
                        <div>
                            {
                                options.map((data,i)=> {
                                    return(
                                        <li key={i}>
                                            <div className="option-select-box" style={{ marginBottom : i === options.length - 1 ? 0 : 8 }}>
                                                <div className="row">
                                                    <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width : 24, height : 24, userSelect : 'none', marginRight : 8, pointerEvents : 'none' }} />
                                                    <p className="option-title" style={{ marginLeft : 0 }}>{data.Name.ko}</p>
                                                </div>
                                                <p className="option-desc">
                                                    {
                                                        data.OptionInfo.map((item,index) => {
                                                            return item.Name.ko + ( index === data.OptionInfo.length - 1 ? '' : ',')
                                                        })
                                                    }
                                                </p>
                                                {
                                                    data.ConnectedMenuInfo.length > 0 && 
                                                    <div className="option-related-box">
                                                        <div className="option-related-title-box">
                                                            <p className="options-related-title">옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                                        </div>
                                                        <p className="option-related-desc">
                                                            {
                                                                data.ConnectedMenuInfo.map((item,index) => {
                                                                    return item.Name.ko + ( index === data.ConnectedMenuInfo.length - 1 ? '' : ',')
                                                                })
                                                            }
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </div>
                    }
                    </ReactDragListView>
                </div>
            }


            {
                step === 5 &&
                <div>
                    <p className="label" style={{ marginTop : 16 }}>메뉴명</p>
                    <p className="text">{name.ko}</p>
                    <div className="divider" style={{ margin : 0 }} /> 

                    <p className="label" style={{ marginTop : 16 }}>가격 구성</p>
                    <div style={{ marginTop : 8, marginBottom : 16 }}>
                    {
                        price.map((data,i) => {
                            return (
                                <React.Fragment key={i}>
                                    {i !== 0 && <div className="divider" style={{ margin : '8px 0' }} />}
                                    <p key={i} className="text" style={{ margin : 0}}>{data.Name.ko} : {convertCost(data.Price)}원</p>
                                </React.Fragment>
                            )
                        })
                    }
                    </div>
                    <div className="divider" style={{ margin : 0 }} />

                    <p className="label" style={{ marginTop : 16 }}>메뉴설명</p>
                        <p className="text">{desc.ko}</p>
                    <div className="divider" style={{ margin : 0 }} />
                    {support_language.map(item => language[item.value] && 
                        <>
                            <p className="title" style={{marginTop : 16}}>{item.text}</p>
                            <p className="label" style={{margin: 0}}>메뉴명</p>
                            <p className="text">{name[item.value]}</p>

                            <p className="label" style={{ marginTop : 16 }}>가격 구성</p>
                            <div style={{ marginTop : 8, marginBottom : 16 }}>
                            {
                                price.map((data,i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            {i !== 0 && <div className="divider" style={{ margin : '8px 0' }} />}
                                            <p key={i} className="text" style={{ margin : 0}}>{data.Name[item.value]} : {convertCost(data.Price)}원</p>
                                        </React.Fragment>
                                    )
                                })
                            }
                            </div>

                            <p className="label" style={{ marginTop : 16 }}>메뉴설명</p>
                                <p className="text">{desc[item.value]}</p>
                            <div className="divider" style={{ margin : 0 }} />
                        </>
                    )}

                    <p className="label" style={{ marginTop : 16, marginBottom : 8 }}>옵션그룹</p>
                    {
                        options.map((data,i) => {
                            return (
                                <div key={i} className="option-select-box" style={{ marginBottom : i === options.length - 1 ? 0 : 8 }} key={i}>
                                    <div className="row">
                                        <p className="option-title">{data.Name.ko}</p>
                                    </div>
                                    <p className="option-desc">{data.OptionInfo.map((item, index) => item.Name.ko + (index + 1 !== data.OptionInfo.length ? ', ' : ''))}</p>
                                    <div className="option-related-box">
                                        <div className="option-related-title-box">
                                            <p className="options-related-title">{data.ConnectedMenuInfo.length > 0 ? '옵션과 연결되어 있는 메뉴를 확인해보세요.':'옵션과 연결되어 있는 메뉴가 없습니다.'}</p>
                                        </div>
                                        <p className="option-related-desc">{data.ConnectedMenuInfo.map((item, index) => item.Name.ko + (index + 1 !== data.OptionInfo.length ? ', ' : ''))}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            }


            <div className='btn-row'>
                {
                    step !== 1 &&
                    <Button variant="outline" className='save-btn' fontSize={16} onClick={() => setStep(old => old -1)} style={{ marginRight : 24 }}>
                        이전
                    </Button>
                }
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => nextStep()} disabled={isDisabled()}>
                    {step === 5 ? '수정하기' : '다음'}
                </Button>
            </div>

            <Modal ref={optionRef} contentContainer={{ width : 500, height : '80%', overflow : 'scroll' }} isHeader title={'옵션 선택'}>
                <>
                {
                    optionList.length > 0 &&
                    <div>
                        {
                            optionList.map((data,i) => {
                                return (
                                    <div className="option-select-box" key={i} style={{ marginBottom : i === optionList.length - 1 ? 0 : 8 }}>
                                        <div className="row">
                                            <CheckBox containerStyle={{ marginBottom : 24 }} checked={getChecked(data._id.$oid)} label="" onChange={() => handleOptions(data)} />
                                            <p className="option-title">{data.Name.ko}</p>
                                        </div>
                                        <p className="option-desc">
                                        {
                                            data.OptionInfo.map((item,index) => {
                                                return item.Name.ko + ( index === data.OptionInfo.length - 1 ? '' : ',')
                                            })
                                        }
                                        </p>
                                        {
                                            data.ConnectedMenuInfo.length > 0 && 
                                            <div className="option-related-box">
                                                <div className="option-related-title-box">
                                                    <p className="options-related-title">옵션과 연결되어있는 메뉴를 확인해보세요.</p>
                                                </div>
                                                <p className="option-related-desc">
                                                    {
                                                        data.ConnectedMenuInfo.map((item,index) => {
                                                            return item.Name.ko + ( index === data.ConnectedMenuInfo.length - 1 ? '' : ',')
                                                        })
                                                    }
                                                </p>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                        <div className='btn-row'>
                            <Button variant="main" className='save-btn' fontSize={16} onClick={() => optionRef.current.closeModal()}>
                                확인
                            </Button>
                        </div>
                    </div>
                }
                </>
            </Modal>
        </div>
    )
}

export default ModifyMenu;